import React, { useEffect, useState, useRef } from 'react'
import { CSSTransition } from 'react-transition-group'
import classNames from 'classnames'
import * as defs from './Modal.module.scss'

const Modal = props => {

  const [EventElement, SetEventElement] = useState(null);
  const nodeRef = useRef(null);

  const {
    className: passedClasses = null,
    children,
    dismissable = true,
    showClose = true,
    onClose,
    show
  } = props

  const handleClick = e => {
    switch(e.type) {
      case 'mousedown':
        return SetEventElement(e.target);
      case 'mouseup':
        if (dismissable && e.target.className === defs.modal && e.target === EventElement) {
          return onClose();
        }
      default: break;
    }
  }

  const baseClasses = { [passedClasses]: !!passedClasses }
  const modalClasses = classNames({...baseClasses, [defs.modal]: true})
  const backdropClasses = classNames({...baseClasses, [defs.backdrop]: true})
  const contentClasses = classNames({...baseClasses, [defs.content]: true})

  return (
    <CSSTransition nodeRef={nodeRef} in={show} key='modal-transition' appear unmountOnExit timeout={250} classNames='modal-popup'>
      <div ref={nodeRef} className={defs.wrapper}>
        <div className={backdropClasses} />
        <div className={modalClasses} onMouseDown={handleClick} onMouseUp={handleClick} >
          <div style={{position: 'relative'}} className={contentClasses}>
            {showClose && <button className='dismiss-icon-modal' onClick={onClose} style={{padding: '3px', right: '18px', top: '15px', zIndex: '2', position: 'absolute'}}>Close</button>}
            {children}
          </div>
        </div>
      </div>
    </CSSTransition>
  )

}

export default Modal